import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { Command } from '@/plugins/cad/module/core/Command'

/**
 * 批量添加实体命令，支持撤销。
 */
export class AddEntityCommand extends Command {
  constructor(
    private entities: IEntity[],
    private viewManager: CADViewManager
  ) {
    super()
  }

  /** 将实体加入视图管理器 */
  execute(): void {
    this.viewManager.addEntities(this.entities)
  }

  /** 撤销：从视图管理器移除已添加的实体 */
  undo(): void {
    this.viewManager.deleteEntities(this.entities)
  }
}
